import React, { useState, useMemo, useRef, useEffect } from "react";
import { View, Text, TouchableOpacity, TextInput, Modal } from "react-native-web";
import styles from "./styles";
import RotatingBoxes from "./rotatingBox";
import compareWordWithWordOfTheDay from "./comparedWords";
import ShrinkingBar from "./timeBar";

import HowToPlay from "./howToPlay";
import { initializeAnalytics, trackPageView } from "./googleAnalyticsTracking";
import AdComponent from "./popUpAdd";

const MainPage = () => {
  const [incorrectGuess, setIncorrectGuess] = useState(false);
  const [isRotating, setIsRotating] = useState(false);
  const [inputActive, setInputActive] = useState(false);
  const [textInputValue, setTextInputValue] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [enteredWords, setEnteredWords] = useState({
    4: [],
    5: [],
    6: []
  });
  const [guessHistory, setGuessHistory] = useState({
    4: [],
    5: [],
    6: []
  });

  const [gameStarted, setGameStarted] = useState({
    4: false,
    5: false,
    6: false
  });
  const [gameEnded, setGameEnded] = useState({
    4: false,
    5: false,
    6: false
  });

  const [isWordTooLong, setIsWordTooLong] = useState(false);
  const [selectedWordLength, setSelectedWordLength] = useState(4);
  const [wordOfTheDay, setWordOfTheDay] = useState("");
  const [phasedLetters, setLetters] = useState("");
  const [remainingLetters, setRemainingLetters] = useState("");
  const [savedGames, setSavedGames] = useState([]);
  const [score, setScore] = useState({
    4: 100,
    5: 100,
    6: 100
  });

  const tempDate = "Wed Jan 01 2025 00:00:00 GMT+0000";
 
  const totalTime = 100;

  useEffect(() => {
    initializeAnalytics();
    trackPageView(window.location.pathname); // Track initial page load
  }, []);
  const checkIfGameEnded = () => {
    const existingData = JSON.parse(localStorage.getItem("gameData") || "{}");
    const today =  new Date().toISOString().split("T")[0];;

    // Check if the selected word length has any game data for today
    const currentGameData = existingData[selectedWordLength] || [];
    const gameForToday = currentGameData.find(
      (game) => game.date.split("T")[0] === today
    );

    if (gameForToday) {
      setGameEnded((prevState) => ({
        ...prevState,
        [selectedWordLength]: true, // Set to true if there is a game entry for today
      }));
    }
  };

  useEffect(() => {
    checkIfGameEnded();
    setIsRotating(true);
    setInputActive(true);
  }, [selectedWordLength]);


  useEffect(() => {
    checkIfGameEnded();
    setIsRotating(true);
    setInputActive(true);
  }, [selectedWordLength]);

  const updateScore = (newWidth) => {
    setScore((prevScore) => {
      const updatedScore = {
        ...prevScore,
        [selectedWordLength]: Math.round(newWidth), // Use the width to calculate score
      };
      return updatedScore;
    });
  };

  const handleIncorrectGuess = () => {
    setIncorrectGuess(true);
    console.log("Incorrect guess made!!!!!!!!!!!!");
  };

  const handleWordLengthSelect = async (length) => {
    let filePath;
    if (length === 4) {
      filePath = "/words/fourLetters.json";
    } else if (length === 5) {
      filePath = "/words/fiveLetters.json";
    } else if (length === 6) {
      filePath = "/words/sixLetters.json";
    }

    try {
      const response = await fetch(filePath);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();

      const todaysDate =  new Date();
      const startDate = new Date("Sun Dec 29 2024 00:00:00 GMT+0000");
      const differenceInMilliseconds = todaysDate - startDate;
      const differenceInDays = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));

      const word = data?.[differenceInDays]?.word || "";
      const letters = data[differenceInDays].letters
        .map((x) => x.toUpperCase())
        .concat(new Array(data[differenceInDays].remainingLetters.length).fill("?"));
      const remainingLetters = data[differenceInDays].remainingLetters.map((x) => x.toUpperCase());

      setWordOfTheDay(word);
      setLetters(letters);
      setRemainingLetters(remainingLetters);
      setSelectedWordLength(length);
    } catch (error) {
      console.error("Error loading JSON file:", error);
    }
  };

  useEffect(() => {
    handleWordLengthSelect(selectedWordLength);
  }, [selectedWordLength]);

  const saveGameData = () => {
    const gameData = {
      date: new Date().toISOString(),
      word: wordOfTheDay,
      numberOfGuesses: guessHistory[selectedWordLength].length + 1,
      wordGuesses: guessHistory[selectedWordLength].concat(wordOfTheDay),
      score: score[selectedWordLength],
    };
    console.log("GameData", gameData);

    const existingData = JSON.parse(localStorage.getItem("gameData") || "{}");

    if (!existingData[selectedWordLength]) {
      existingData[selectedWordLength] = [];
    }
    existingData[selectedWordLength].push(gameData);

    localStorage.setItem("gameData", JSON.stringify(existingData));

    setSavedGames(existingData);
  };

  const clearGameData = () => {
    localStorage.removeItem("gameData");
    setSavedGames([]);
  };

  const toggleModal = () => {
    setModalVisible(!modalVisible);
  };

  const textInputRef = useRef(null);
  const handleBeginClick = () => {
    checkIfGameEnded();

    // Prevent starting a new game if it has already ended for the selected word length
    if (gameEnded[selectedWordLength]) {
      if (selectedWordLength === 6) {
        alert("Thanks for playing!");
      } else {
        // Reset game state for the current word length before moving to the next
        resetGameStateForNextRound();

        // Move to the next word length after finishing current one
        const nextLength = selectedWordLength + 1;
        handleWordLengthSelect(nextLength); // Start next game
      }
      return; // Prevent starting a new game
    }

    setIsRotating(true);
    setInputActive(true);

    // Mark the game as started for the selected word length
    setGameStarted((prevState) => ({
      ...prevState,
      [selectedWordLength]: true,
    }));

    setTimeout(() => {
      textInputRef.current?.focus();
    }, 0);
  };

  const resetGameStateForNextRound = () => {
    setIncorrectGuess(false);
    setTextInputValue("");
    setEnteredWords({
      4: [],
      5: [],
      6: []
    });
    setGuessHistory({
      4: [],
      5: [],
      6: []
    });
    setScore({
      4: 100,
      5: 100,
      6: 100
    });
  };

  const handleNextRound = () => {
    const nextLength = selectedWordLength + 1;
    if (nextLength <= 6) {
      handleWordLengthSelect(nextLength); // Start next game
    } else {
      // Do nothing, just show the "Thanks" message
    }
  };

  const handleTextInputChange = (text) => {
    setTextInputValue(text);
    if (text.length > wordOfTheDay.length) {
      setIsWordTooLong(true);
    } else {
      setIsWordTooLong(false);
    }
  };

  const handleTextInputSubmit = () => {
    if (textInputValue.trim() !== "") {
      const trimmedWord = textInputValue.trim().toLowerCase();
      const wordLength = trimmedWord.length;

      setGuessHistory((prevHistory) => {
        const updatedHistory = {
          ...prevHistory,
          [selectedWordLength]: [
            ...(prevHistory[selectedWordLength] || []),
            trimmedWord,
          ],
        };
        return updatedHistory;
      });

      setEnteredWords((prevWords) => ({
        ...prevWords,
        [selectedWordLength]: [
          ...prevWords[selectedWordLength],
          trimmedWord,
        ],
      }));

      if (trimmedWord === wordOfTheDay.toLowerCase()) {
        saveGameData();
        setGameEnded((prevState) => ({
          ...prevState,
          [selectedWordLength]: true, // Mark game as ended
        }));
      }

      setTextInputValue("");
      setIsWordTooLong(false);
      
    }
  };

  useEffect(() => {
    if (inputActive) {
      textInputRef.current?.focus();
    }
  }, [inputActive, enteredWords]);

  const renderColoredLetters = (word, comparisonResult) => {
    return word.split("").map((letter, index) => {
      const comparison = comparisonResult[index];
      const color = comparison ? comparison.color : "black";
      return (
        <Text key={index} style={{ color }}>
          {letter}
        </Text>
      );
    });
  };

  const resetIncorrectGuess = () => {
    setIncorrectGuess(false);
  };

  const rotatingBoxesComponent = useMemo(() => {
    if (!gameStarted[selectedWordLength]) return null;

    return (
      <RotatingBoxes
        letters={phasedLetters}
        remainingLetters={remainingLetters}
        isRotating={isRotating}
        correctWord={wordOfTheDay}
        enteredWord={
          enteredWords[selectedWordLength][enteredWords[selectedWordLength].length - 1] || ""
        }
        gameStarted={gameStarted[selectedWordLength]}
        gameEnded={gameEnded[selectedWordLength]}
        timeBetweenReveal={12 * 1000}
        selectedWordLength={selectedWordLength}
        onIncorrectGuess={handleIncorrectGuess}
      />
    );
  }, [
    gameStarted[selectedWordLength],
    phasedLetters,
    remainingLetters,
    isRotating,
    wordOfTheDay,
    enteredWords[selectedWordLength],
  ]);


  return (
    <View style={styles.landingPage}>
      <AdComponent/>
      <View style={styles.wordSelectContainer}>
        <View style={styles.wordSelectZone}>
          {[4, 5, 6].map((length) => (
            <TouchableOpacity
              key={length}
              style={[
                styles.wordSelect,
                selectedWordLength === length
                  ? styles.selectedWordSelect
                  : styles.unselectedWordSelect,
              ]}
              onPress={() => {
                handleWordLengthSelect(length);
              }}
            >
              <Text style={styles.wordSelectText}>{length}</Text>
            </TouchableOpacity>
          ))}
        </View>
        <TouchableOpacity onPress={toggleModal} style={styles.helpButton}>
          <Text style={styles.helpButtonText}>How to play</Text>
        </TouchableOpacity>
        <Modal
          animationType="fade"
          transparent={true}
          visible={modalVisible}
          onRequestClose={toggleModal}
        >
          <TouchableOpacity style={styles.modalOverlay} onPress={toggleModal}>
            <View style={styles.modalContentHowToPlay}>
              <TouchableOpacity onPress={toggleModal} style={styles.closeButton}>
                <Text style={styles.closeButtonText}>X</Text>
              </TouchableOpacity>
              <HowToPlay />
            </View>
          </TouchableOpacity>
        </Modal>
      </View>

      <View style={styles.timerCountdown}>
        <ShrinkingBar
          shrinkTime={totalTime}
          gameStarted={gameStarted[selectedWordLength]}
          gameEnded={gameEnded[selectedWordLength]}
          updateScore={updateScore}
          selectedWordLength={selectedWordLength}
          score={score}
          incorrectGuess={incorrectGuess}
          resetIncorrectGuess={resetIncorrectGuess}
        />

      </View>

      <View style={styles.wordBoxZone}>
        {rotatingBoxesComponent}
      </View>

      <View style={styles.beginButtonZone}>
        {inputActive && gameStarted[selectedWordLength] === true ? (
          <>
            {!gameEnded[selectedWordLength] && (
              <View style={[styles.inputContainer, { flexDirection: 'row', alignItems: 'center' }]}>
              <TextInput
                ref={textInputRef}
                style={[styles.textInput, { flex: 1 }]} // Ensure the input takes up available space
                placeholder="Type your answer..."
                value={textInputValue}
                onChangeText={handleTextInputChange}
                onSubmitEditing={handleTextInputSubmit}
              />
              <TouchableOpacity
                style={styles.submitButton} // Define this style in your styles file
                onPress={handleTextInputSubmit}
              >
                <Text style={styles.submitButtonText}>Submit</Text> {/* Add any desired text styling */}
              </TouchableOpacity>
            </View>
            )}

            <View
              style={[
                styles.warningPill,
                isWordTooLong ? { opacity: 1 } : { opacity: 0 },
              ]}
            >
              <Text style={styles.warningPillText}>Word is too long!</Text>
            </View>
            {
              gameEnded[selectedWordLength] ? (
                <TouchableOpacity style={[styles.beginButton, { width: "20%" }]} onPress={handleNextRound}>
                  <Text style={styles.beginButtonText}>
                    {selectedWordLength === 6 ? "Thanks for playing today!" : "Play Next Round"}
                  </Text>
                </TouchableOpacity>
              ) : null
            }
            <View style={[styles.guessesTitleZone, { marginTop: "2.5%" }]}>
              <Text style={styles.guessesTitle}>Guesses:</Text>
            </View>

            <View style={styles.enteredWordsContainer}>
              {enteredWords[selectedWordLength].map((word, index) => {
                const comparisonResult = compareWordWithWordOfTheDay(word, wordOfTheDay);
                return (
                  <View key={index} style={styles.pill}>
                    <Text style={styles.pillText}>
                      {renderColoredLetters(word, comparisonResult)}
                    </Text>
                  </View>
                );
              })}
            </View>


          </>

        ) : (
          <TouchableOpacity style={styles.beginButton} onPress={handleBeginClick}>
            <Text style={styles.beginButtonText}>Begin</Text>
          </TouchableOpacity>
        )

        }

      </View>
      {/* <TouchableOpacity style={styles.clearGameDataButton} onPress={clearGameData}>
        <Text style={styles.clearGameDataButtonText}>Clear Saved Game Data</Text>
      </TouchableOpacity> */}
    </View>
  );
};

export default MainPage;
